<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'周目标管理'}]" />-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="创客">
                                <el-input v-model="q.userCode" placeholder="请输入创客姓名/工号" :clearable="true"></el-input>
                            </el-form-item>
<!--                            <el-form-item label="抢入链群">-->
<!--                                <el-select filterable v-model="q.searchLianqun" clearable placeholder="请选择"-->
<!--                                >-->
<!--                                    <el-option-->
<!--                                            v-for="(item,index) in lianqunList"-->
<!--                                            :key="item.chainGroupCode"-->
<!--                                            :label="item.chainGroupName"-->
<!--                                            :value="item.chainGroupCode">-->
<!--                                    </el-option>-->
<!--                                </el-select>-->
<!--                            </el-form-item>-->
                            <el-form-item label="抢入链群" prop="lianqun">
                              <brselect category="crm_lianqun" :v="q.searchLianqun" :showcode="true"
                                        v-model="q.searchLianqun" clearable></brselect>
                            </el-form-item>
<!--                            <el-form-item label="区域">
                                <el-select filterable v-model="q.searchQuyu" clearable placeholder="请选择"
                                >
                                    <el-option
                                            v-for="(item,index) in quyuList"
                                            :key="item.code"
                                            :label="item.name"
                                            :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>-->
                          <el-form-item label="区域" prop="searchQuyu">
                            <brselect clearable category="show_area" :v="q.searchQuyu"
                                      v-model="q.searchQuyu"></brselect>
                          </el-form-item>

                            <el-form-item label="是否周清">
                                <el-select filterable v-model="q.searchYq" clearable placeholder="请选择">
                                    <el-option value="1" label="已周清"></el-option>
                                    <el-option value="0" label="未周清"></el-option>
                                </el-select>
                            </el-form-item>

                        </div>
                        <el-collapse-transition>
                            <div v-show="isScreen">
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="年度">
                                        <el-select filterable v-model="q.year" clearable placeholder="请选择"
                                                   @change="getqWeeksBySelectYear">
                                            <el-option
                                                    v-for="(item,index) in yearList"
                                                    :key="item"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
<!--                                    <el-form-item  label="月" class="h-elformWrap-2" prop="username">
                                        <el-select filterable v-model="q.month" clearable placeholder="请选择"
                                        >
                                            <el-option
                                                    v-for="(item,index) in monthList"
                                                    :key="item"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>-->
                                    <el-form-item  label="周" class="h-elformWrap-2" prop="username">
                                        <el-select filterable v-model="q.week" clearable  placeholder="请选择"
                                        >
                                            <el-option
                                                    v-for="(item,index) in qweekList"
                                                    :key="item.week"
                                                    :label="item.weekStr"
                                                    :value="item.week">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
<!--                                    <el-form-item label="链群类型">-->
<!--                                        <el-select filterable v-model="q.lqType" clearable placeholder="请选择"-->
<!--                                        >-->
<!--                                            <el-option label="创单链群" value="0"></el-option>-->
<!--                                            <el-option label="体验链群" value="1"></el-option>-->
<!--                                        </el-select>-->
<!--                                    </el-form-item>-->
                                  <el-form-item label="目标类型">
                                    <el-select filterable v-model="q.targetType" clearable placeholder="请选择"
                                    >
                                      <el-option label="日常" value="0"></el-option>
                                      <el-option label="城市网" value="1"></el-option>
                                    </el-select>
                                  </el-form-item>
                                  <el-form-item label="部门">
                                    <el-select filterable v-model="q.cdept" clearable placeholder="请选择"
                                    >
                                      <el-option
                                          v-for="(item,index) in deptList"
                                          :key="item.dept"
                                          :label="item.dept"
                                          :value="item.dept">
                                      </el-option>
                                    </el-select>
                                  </el-form-item>

                                </div>
<!--                                <div class="h-thirdColumn w-newColumn">-->
<!--                                   -->
<!--                                </div>-->
                            </div>
                        </el-collapse-transition>

                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                        </div>
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
                                新建目标
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <el-table
                        ref="multipleTable"
                        @selection-change="handleSelectionChange"
                        :data="tableData"
                        :border="true"
                        stripe
                        max-height="560"
                        style="width: 100%"
                >
                    <!--            <el-table-column prop="daquName" label="大区" width="50" :show-overflow-tooltip="true"></el-table-column>-->
                    <el-table-column prop="userName" label="创客" width="70" ></el-table-column>
                    <el-table-column prop="lianqunName" label="抢入链群" width="80" ></el-table-column>
                    <el-table-column prop="quyuName" label="区域" width="80" ></el-table-column>
                    <el-table-column prop="deptName" label="部门" width="80" ></el-table-column>
                    <el-table-column prop="targetTypeName" label="类型" width="80" ></el-table-column>

                    <el-table-column prop="year" label="年度" width="50" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="weekStr" label="周" width="130" :show-overflow-tooltip="true">
                        <template scope="scope">
                            {{scope.row.weekStr}}
                        </template>
                    </el-table-column>

                    <!--            <el-table-column prop="cdate" label="提报时间"  width="90" :show-overflow-tooltip="true"></el-table-column>-->

                    <el-table-column prop="targetContent" label="目标内容" >
                        <template slot-scope="scope">

                            <el-tooltip placement="top">
                                <div slot="content"><pre align="left"  style="max-width: 500px;">{{scope.row.targetContent}}</pre></div>
                                <pre align="left" >{{scope.row.targetContent}}</pre>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="summaryContent" label="总结">
                        <template slot-scope="scope">

                            <el-tooltip placement="top">
                                <div slot="content"><pre align="left"  style="max-width: 500px;">{{scope.row.summaryContent}}</pre></div>
                                <pre align="left" >{{scope.row.summaryContent}}</pre>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="comment" label="预实差评价"     >
                        <template slot-scope="scope">
                            <!--                    <el-input class="h-tableInput" v-model="scope.row.comment" :clearable="true"></el-input>-->
                            <el-input v-if="scope.row.id" type="textarea" v-model="scope.row.comment" placeholder="请输入" class="h-txtareaBox" rows = "2" ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sysScore" label="评价" width="80">
                        <template slot-scope="scope">
                            <brselect v-if="scope.row.id " class="h-tableInput" category="userCareLevel" :v="scope.row.sysScore" v-model="scope.row.sysScore"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            fixed="right"
                            width="150"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.id " style="text-align: left;">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="showDetail(scope.row.id)"
                                >总结</el-button>
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="updateDetail(scope.row.id)"
                                >编辑</el-button>
                                <el-button
                                        type="text"
                                        size="small"
                                        style="padding: 0;"
                                        class="h-tableLink h-btn"
                                        @click="del(scope.row.id)">
                                    删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" v-auth="'zhoumubiaopingjia'" @click="saveGrade">调整评分</el-button>
                        </div>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query" />
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="newDialog" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>新建目标</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div style="padding: 12px;" class="dialogout X-dai">
                    <el-form :model="add" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine h-formbLine1">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceCon2">
                                    <div class="h-formLine" style="margin-right:60px" >
<!--                                        <el-form-item label="类型" class="h-elformWrap-2" prop="username" >-->
<!--                                            <el-select filterable v-model="add.type" disabled placeholder="请选择">-->
<!--                                                <el-option-->
<!--                                                        v-for="(item,index) in typeList"-->
<!--                                                        :key="item.type"-->
<!--                                                        :label="item.text"-->
<!--                                                        :value="item.type">-->
<!--                                                </el-option>-->
<!--                                            </el-select>-->
<!--                                        </el-form-item>-->
                                      <el-form-item   label="链群" class="h-elformWrap-2" prop="username" >
                                        <brselect category="ld_lianqun" :v="add.lianqunCode" v-model="add.lianqunCode" :clearable="true"/>
                                      </el-form-item>
                                    </div>
                                    <div class="h-formLine" style="margin-right:60px">
                                        <el-form-item label="年度" class="h-elformWrap-2" prop="username">
                                            <el-select filterable v-model="add.year"  placeholder="请选择"
                                                       @change="getWeeksBySelectYear">
                                                <el-option
                                                        v-for="(item,index) in yearList"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="add.type == 1" label="月" class="h-elformWrap-2" prop="username">
                                            <el-select filterable v-model="add.month" placeholder="请选择"
                                            >
                                                <el-option
                                                        v-for="(item,index) in monthList"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="add.type == 2" label="周" class="h-elformWrap-3" prop="username">
                                            <el-select filterable v-model="add.week"  placeholder="请选择"
                                                       @change="getLianqunBySelectWeek"
                                            >
                                                <el-option
                                                        v-for="(item,index) in weekList"
                                                        :key="item.week"
                                                        :label="item.weekStr"
                                                        :value="item.week">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="h-formLine" style="margin-right:60px">
                                        <el-form-item label="链群" class="h-elformWrap-2" v-if="this.addlianqunList.length >0">
                                            <el-select filterable v-model="add.lianqun" clearable placeholder="请选择"
                                                       @change="$forceUpdate()"
                                            >
                                                <el-option
                                                        v-for="(item,index) in addlianqunList"
                                                        :key="item.chainGroupCode"
                                                        :label="item.chainGroupName"
                                                        :value="item.chainGroupCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>

                                        <el-form-item label="目标内容" class="h-elformWrap-1">
                                            <el-input type="textarea" v-model="add.targetContent" placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                    <!--                    <el-button class="h-btn h-bBtn h-bggreen" @click="saveCreate" v-show="isShowSaveCredit">暂存-->
                    <!--                    </el-button>-->
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
                </div>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="showDialog" v-loading="showloading" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>总结</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div style="padding: 12px;" class="dialogout X-dai">
                    <el-form :model="add" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine h-formbLine1">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceCon2">
                                    <div class="h-formLine" style="margin-right:60px">
                                        <el-form-item label="类型" class="h-elformWrap-2" prop="username">
                                            <el-select filterable v-model="add.type" disabled placeholder="请选择">
                                                <el-option
                                                        v-for="(item,index) in typeList"
                                                        :key="item.type"
                                                        :label="item.text"
                                                        :value="item.type">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="h-formLine" style="margin-right:60px">
                                        <el-form-item label="年度" class="h-elformWrap-2" prop="username">
                                            <el-select filterable v-model="add.year" disabled  placeholder="请选择"
                                                       @change="getWeeksBySelectYear">
                                                <el-option
                                                        v-for="(item,index) in yearList"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="add.type == 1" label="月" class="h-elformWrap-2" prop="username">
                                            <el-select filterable v-model="add.month" disabled placeholder="请选择"
                                            >
                                                <el-option
                                                        v-for="(item,index) in monthList"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="add.type == 2" label="周" class="h-elformWrap-3" prop="username">
                                            <el-select filterable v-model="add.week" disabled  placeholder="请选择"
                                            >
                                                <el-option
                                                        v-for="(item,index) in weekList"
                                                        :key="item.week"
                                                        :label="item.weekStr"
                                                        :value="item.week">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>

                                        <el-form-item label="目标内容" class="h-elformWrap-1">
                                            <el-input type="textarea" v-model="add.targetContent" disabled placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                                        </el-form-item>

                                        <el-form-item label="总结" class="h-elformWrap-1">
                                            <el-input type="textarea" v-model="add.summaryContent" placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="updateDialog" v-loading="updateloading" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>修改目标</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div style="padding: 12px;" class="dialogout X-dai">
                    <el-form :model="add" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine h-formbLine1">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceCon2">
                                    <div class="h-formLine" style="margin-right:60px">
<!--                                        <el-form-item label="类型" class="h-elformWrap-2" prop="username">-->
<!--                                            <el-select filterable v-model="add.type" disabled placeholder="请选择">-->
<!--                                                <el-option-->
<!--                                                        v-for="(item,index) in typeList"-->
<!--                                                        :key="item.type"-->
<!--                                                        :label="item.text"-->
<!--                                                        :value="item.type">-->
<!--                                                </el-option>-->
<!--                                            </el-select>-->
<!--                                        </el-form-item>-->
                                      <el-form-item   label="链群" class="h-elformWrap-2">
                                        <brselect category="ld_lianqun" :v="add.lianqunCode" v-model="add.lianqunCode" :clearable="true"/>
                                      </el-form-item>
                                    </div>
                                    <div class="h-formLine" style="margin-right:60px">
                                        <el-form-item label="年度" class="h-elformWrap-2" prop="username">
                                            <el-select filterable v-model="add.year"  placeholder="请选择"
                                                       @change="getWeeksBySelectYear">
                                                <el-option
                                                        v-for="(item,index) in yearList"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="add.type == 1" label="月" class="h-elformWrap-2" prop="username">
                                            <el-select filterable v-model="add.month" placeholder="请选择"
                                            >
                                                <el-option
                                                        v-for="(item,index) in monthList"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="add.type == 2" label="周" class="h-elformWrap-3" prop="username">
                                            <el-select filterable v-model="add.week"  placeholder="请选择"
                                                       @change="getLianqunBySelectWeek"
                                            >
                                                <el-option
                                                        v-for="(item,index) in weekList"
                                                        :key="item.week"
                                                        :label="item.weekStr"
                                                        :value="item.week">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="链群" class="h-elformWrap-2" v-if="this.addlianqunList.length >0">
                                            <el-select filterable v-model="add.lianqun" clearable placeholder="请选择"
                                                       @change="$forceUpdate()"
                                            >
                                                <el-option
                                                        v-for="(item,index) in addlianqunList"
                                                        :key="item.chainGroupCode"
                                                        :label="item.chainGroupName"
                                                        :value="item.chainGroupCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="目标内容" class="h-elformWrap-1">
                                            <el-input type="textarea" v-model="add.targetContent" placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from "../../../api/SystemService";
    import updownfile from '../../../utils/updownfile'
    import util from "../../../utils/util";
    import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
    import moment from "moment";
    export default {
        data() {
            return {
                // 展开折叠筛选
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //表单
                q: {
                    year:new Date().getFullYear(),
                    cdsDate:null,
                    type : 2,
                    lqType : 0,
                    pageSize: 10,
                    pageNo: 1,
                    total:0,
                    cdept:'',
                },
                add:{
                    year :new Date().getFullYear(),
                    type : 2,
                    month :new Date().getMonth()+2,
                    lianqunCode:'',
                    lianqunName: '',
                },
                isfb:1,
                showhistory:false,
                instid:null,
                pingfen:'暂无',
                paiming:'暂无',
                //表格
                multipleSelection: [],
                multipleSelectionDialog:[],
                tableData: [],
                //发布排行
                dialogFlag:false,

                sumRank:[],
                quyuList:[],
                yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
                qyearList:[],
                deptList: [],
                typeList:[{type:1,text:'月目标'},{type:2,text:'周目标'}],
                monthList:[1,2,3,4,5,6,7,8,9,10,11,12],
                weekList :[],
                lianqunList : [],
                addlianqunList : [],
                qweekList :[],
                newDialog: false,
                showDialog:false,
                updateDialog:false,
                showloading:false,
                updateloading:false,
                nosum:'',
                nosoc:'',
                q2: {
                    pageSize: 10,
                    pageNo: 1,
                    total:0,
                    rqstatus:'',
                },
            };
        },
        created() {
            this.getAllLianqun();
            this.getQuyu();
            this.getqWeeks(new Date().getFullYear(),1);
            this.getWeeks(new Date().getFullYear());
            for(var i =2021;i<new Date() .getFullYear()+2;i++){
                this.qyearList.push(i);
            }
            this.getDept();
          this.q.week = this.getWeekNum()

        },

        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        methods: {
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            readd(){
                this.add={
                    year :new Date().getFullYear(),
                    type : 2,
                    month :new Date().getMonth()+2
                }
            },
            //调整评分
            saveGrade(){

                ss.MuBiao.tzGrade({"list":this.tableData}).then(rd => {
                    this.$msg.msgs("调整保存成功");
                    this.query();
                })


            },
          getDept(q){
            ss.MuBiao.getDeptList(q).then(rd => {
              this.deptList = rd;
            })
          },
            getQuyu(){
                ss.RiqPingj.selectAllQuyu().then(rd => {
                    this.quyuList = rd;
                })
            },
            genzongLiuch(r){
                this.instid = r.instid;
                this.showhistory = true;
            },
            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //弹框表格
            handleSelectionChangeDialog(val){
                this.multipleSelectionDialog = val;
            },
            getLianqun(q){
                ss.createMonthGoal.getLianqun(q).then(rd => {
                    this.lianqunList = rd;
                })
            },
            getWeeks(y){
                ss.MuBiao.getWeekList({year:y}).then(rd => {
                    this.weekList = rd;
                })
            },
            getqWeeks(y,z){
                ss.MuBiao.getWeekList({year:y,stype:z}).then(rd => {
                    this.qweekList = rd;
                    this.getKnowWeek();
                })
            },
            getKnowWeek() {
              var week1 = this.getWeekNum();
              this.qweekList.forEach(element => {
                if(week1 == element.week){
                  this.q.week = element.week
                }
              });
            },
            getWeeksBySelectYear(){
                this.getWeeks(this.add.year);
                ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
                    this.addlianqunList = rd;
                })
            },
            getLianqunBySelectWeek(){
                ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
                    this.addlianqunList = rd;
                })
                this.add.lianqun ="";
            },
            getqWeeksBySelectYear(){
                this.getqWeeks(this.q.year,1);
            },
            getWeekNum() {
              //获得当前日期是第几周的方法
              var year = new Date().getFullYear();
              var week = moment(new Date()).format("E");//获得今天是星期几
              console.log("week",week)
              var startweek = moment(new Date(year + "-01-01")).format("E");//获得今年的1月1号是星期几
              //今天到1月1号的时间戳之差
              var millisDiff =
                  new Date(moment().format("yyyy-MM-DD")).getTime() -
                  new Date(year + "-01-01").getTime();
              var days =
                  (millisDiff -
                      week * (24 * 60 * 60 * 1000) -
                      (7 - startweek) * (24 * 60 * 60 * 1000)) /
                  86400000;
              return days / 7 + 1;
              //这里加的2代表的是本周和今年1月1号所在的那一周
            },
            commitCreate() {
                if(!this.add.type){
                    this.$message({
                        type: "error",
                        message: '类型不能为空'
                    });
                    return false;
                }
                if(!this.add.lianqunCode){
                  this.$message({
                    type: "error",
                    message: '链群不能为空'
                  });
                  return false;
                }
                if(!this.add.year){
                    this.$message({
                        type: "error",
                        message: '年度不能为空'
                    });
                    return false;
                }
                if(this.add.type == 1 &&!this.add.month){
                    this.$message({
                        type: "error",
                        message: '月度不能为空'
                    });
                    return false;
                }
                if(this.add.type == 2 &&!this.add.week){
                    this.$message({
                        type: "error",
                        message: '周不能为空'
                    });
                    return false;
                }
                if(!this.add.targetContent){
                    this.$message({
                        type: "error",
                        message: '目标内容不能为空'
                    });
                    return false;
                }

                if(this.add.type == 1)
                    this.add.week = null
                if(this.add.type == 2)
                    this.add.month = null

                ss.MuBiao.saveOrUpdateCk(this.add).then(response => {
                    if (response.f) {
                        this.$message({
                            type: "success",
                            message: response.msg
                        });
                        //this.readd();
                        this.query();
                        this.newDialog = false;
                        this.showDialog = false;
                        this.updateDialog = false;
                    } else {
                        this.$message({
                            type: "error",
                            message: response.msg
                        });
                    }

                })
            },
            del(id){
                this.$confirm("确定要删除吗？", '提示')
                    .then(_ => {
                        ss.MuBiao.del({id:id}).then(response => {
                            this.query();
                            this.$message({
                                type: "success",
                                message: response.msg
                            });
                        })
                    })
                    .catch(_ => {
                    })
            },
            showDetail(id){
                this.showDialog = true;
                this.showloading = true;
                ss.MuBiao.selectById({id:id}).then(rd => {
                    this.add = rd.obj;
                    this.showloading = false;
                });
            },
            updateDetail(id){
                this.updateDialog = true;
                this.updateloading = true;
                ss.MuBiao.selectById({id:id}).then(rd => {
                    this.add = rd.obj;
                    this.add.lianqunName = rd.obj.lianqunName;
                    this.updateloading = false;
                    // ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
                    //     this.addlianqunList = rd;
                    // })
                });
            },
            getAllLianqun(){
                ss.createMonthGoal.getAllLianqun().then(rd => {
                    this.lianqunList = rd;
                })
            },
            query(){
                ss.MuBiao.pageCK(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;

                });
            },
            create(){
                this.add = {
                    year :new Date().getFullYear(),
                    type : 2,

                    month :new Date().getMonth()+2
                },
                    this.newDialog = true;
            },
//取消按钮
            exit() {
                this.newDialog = false;
                this.showDialog = false;
                this.updateDialog = false;
            },
            handleFilter() {
                this.query();
            },
            checkRank() {
                this.$router.push("/paiming");
            },

            typeIndex(index){
                return index+(this.q2.pageNo-1)*this.q2.pageSize+1;
            },

            //明细导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/mubiao/userDailyTarget/downloadExcel",this.q,"post",'data');
            },

            //重置
            rest() {
                var pageSize=this.q.pageSize;
                var pageNo=this.q.pageNo;
                var total=this.q.total;
                var lqType=this.q.lqType;
                var year=this.q.year;
                var type = this.add.type;
                this.q= {
                    pageSize: pageSize,
                    pageNo: pageNo,
                    total:total,
                    lqType: lqType,
                    year: year,
                    type: type,
                }
            },
        },
        mounted() {
            this.query();
        }
    };
</script>

<style>
</style>
<style>
    .chosedialog .body_dilog{
        padding-top: 0px!important;
    }
    .chosedialog .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .chosedialog .el-dialog__body{
        padding: 0px 20px!important;
    }
    .chosedialog .h-pagination{
        padding-top:0px !important;
        padding-bottom:0px !important;
    }
    .ljjcaozuo .el-button [class*=el-icon-]+span{
        margin-left: 0;
    }
    .ljjcaozuo .h-el-icon{
        margin-right: 0;
    }
    .smTableRq .el-table tbody td .cell {
        padding-top: 0.03rem;
        padding-bottom: 0.03rem;
    }
    .smTableRq .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .smTableRq .el-input__inner{
        background: transparent;
    }
    .ljjtablepaddingsrq .h-tableInput{
        margin-top: 0.05rem;
    }
    .ljjtablepaddingsrq .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
        color: #616467;
        font-size: 0.16rem;
    }
    .ljjtablepaddingsrq .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }

    .X-dai .h-formbLine .h-elformWrap-2 {
        padding-right: 0.5rem;
        width: 50% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-3 {
        padding-right: 0.5rem;
        width: 47% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-1 {
        padding-right: 0;
        width: 100% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-1 .el-form-item__label{
        width: 22%;
    }
    .X-dai .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 .el-form-item__label{
        width: 16%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 .el-form-item__content{
        width: 82%;
    }
    .X-dai .h-formbLine .el-form-item__label {
        width: 51%;

    }
    .X-dai .h-formbLine .el-form-item__content {
        width: 49%;
    }
</style>
